import React, { Children } from 'react';
import { motion } from 'framer-motion';
// Custom SVG Icons
const LeafIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-209">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-210" />
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-211" />
  </svg>;
const SproutIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-212">
    <path d="M7 20h10" data-id="element-213" />
    <path d="M10 20c5.5-1.25 6-3.9 6-8a6 6 0 0 0-12 0c0 4.1 .5 6.75 6 8Z" data-id="element-214" />
    <path d="M12 12v8" data-id="element-215" />
    <path d="M12 12c-2.5-1.5-3-4.5-3-7 0-1 0-2 1-2s1 1 1 2c0 2.5.5 5.5 3 7Z" data-id="element-216" />
  </svg>;
const LayersIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-217">
    <polygon points="12 2 2 7 12 12 22 7 12 2" data-id="element-218" />
    <polyline points="2 12 12 17 22 12" data-id="element-219" />
    <polyline points="2 17 12 22 22 17" data-id="element-220" />
  </svg>;
const BrickIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-221">
    <rect x="2" y="4" width="20" height="16" rx="2" data-id="element-222" />
    <path d="M10 4v16" data-id="element-223" />
    <path d="M2 12h20" data-id="element-224" />
    <path d="M16 4v8" data-id="element-225" />
    <path d="M6 12v8" data-id="element-226" />
  </svg>;
const WaterIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-227">
    <path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z" data-id="element-228" />
  </svg>;
const FlowerIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-229">
    <circle cx="12" cy="12" r="3" data-id="element-230" />
    <path d="M12 16.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 1 1 12 7.5a4.5 4.5 0 1 1 4.5 4.5 4.5 4.5 0 1 1-4.5 4.5" data-id="element-231" />
    <path d="M12 22v-3" data-id="element-232" />
  </svg>;
const PlantIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-233">
    <path d="M12 22v-7l-2-2" data-id="element-234" />
    <path d="M12 15l2-2" data-id="element-235" />
    <path d="M8 13c-2.5-1.5-3-4.5-3-7 0-1 0-2 1-2s1 1 1 2c0 2.5.5 5.5 3 7Z" data-id="element-236" />
    <path d="M16 13c2.5-1.5 3-4.5 3-7 0-1 0-2-1-2s-1 1-1 2c0 2.5-.5 5.5-3 7Z" data-id="element-237" />
  </svg>;
const GutterIcon = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="w-8 h-8" data-id="element-238">
    <path d="M4 4v16" data-id="element-239" />
    <path d="M20 4v16" data-id="element-240" />
    <path d="M4 12h16" data-id="element-241" />
    <path d="M4 8h16" data-id="element-242" />
    <path d="M4 16h16" data-id="element-243" />
    <path d="M2 20h20" data-id="element-244" />
  </svg>;
const services = [{
  title: 'Sod Installation',
  description: 'Professional turf that stays green',
  icon: <LeafIcon data-id="element-245" />
}, {
  title: 'Sprig Install',
  description: 'Natural coverage done correctly',
  icon: <SproutIcon data-id="element-246" />
}, {
  title: 'Mulch',
  description: 'Clean, even, finished beds',
  icon: <LayersIcon data-id="element-247" />
}, {
  title: 'Pavers / Tabique',
  description: 'Walkways & borders built to last',
  icon: <BrickIcon data-id="element-248" />
}, {
  title: 'Pressure Wash',
  description: 'Surfaces restored like new',
  icon: <WaterIcon data-id="element-249" />
}, {
  title: 'Seasonal Flowers',
  description: 'Spring · Summer · Fall · Winter',
  icon: <FlowerIcon data-id="element-250" />
}, {
  title: 'Plants & Gardens',
  description: 'Strategic planting & installation',
  icon: <PlantIcon data-id="element-251" />
}, {
  title: 'Gutter / Drainage',
  description: 'Channel systems that protect your foundation & eliminate flooding',
  icon: <GutterIcon data-id="element-252" />
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5
    }
  }
};
export function ServicesSection() {
  return <section id="services" className="py-24 bg-white relative" data-id="element-253">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-254">
        <div className="text-center mb-16" data-id="element-255">
          <h2 className="text-sm font-bold tracking-widest text-forest-700 uppercase mb-3" data-id="element-256">
            What We Do
          </h2>
          <h3 className="text-3xl md:text-5xl font-heading font-bold text-earth-900 mb-6" data-id="element-257">
            Complete Property Services
          </h3>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-258">
            One call, everything covered. We handle every aspect of your
            property's exterior to keep it looking pristine year-round.
          </p>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8" data-id="element-259">
          {services.map((service, index) => <motion.div key={index} variants={itemVariants} className="bg-cream-100 rounded-2xl p-8 border border-cream-200 hover:border-forest-500/30 hover:shadow-lg transition-all duration-300 group" data-id="element-260">
              <div className="w-14 h-14 bg-white rounded-xl shadow-sm flex items-center justify-center text-forest-700 mb-6 group-hover:bg-forest-700 group-hover:text-white transition-colors duration-300" data-id="element-261">
                {service.icon}
              </div>
              <h4 className="text-xl font-bold text-earth-900 mb-3" data-id="element-262">
                {service.title}
              </h4>
              <p className="text-gray-600 leading-relaxed" data-id="element-263">
                {service.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}